/**
 * Small light/dark toggle button. Used by both the client portal and
 * the KG-internal app. Pure presentational - parent supplies the
 * current theme + onToggle callback.
 */

type Theme = 'light' | 'dark';

export function ThemeToggle({
  theme,
  onToggle,
  className,
}: {
  theme: Theme;
  onToggle: () => void;
  className?: string;
}) {
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={isDark}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={
        className ??
        'inline-flex items-center justify-center w-7 h-7 text-kg-grey-700 hover:text-kg-black dark:text-kg-grey-300 dark:hover:text-white transition-colors text-sm bg-kg-grey-100/70 dark:bg-white/[0.05]'
      }
    >
      {isDark ? '☀' : '☾'}
    </button>
  );
}
